(function () {
  "use strict";

  var SCROLL_THRESHOLD = 400;

  function initBackToTop(root) {
    var btn = (root || document).querySelector("[data-back-to-top]");
    if (!btn || btn.dataset.bound === "true") {
      return;
    }
    btn.dataset.bound = "true";

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function setVisible(show) {
      btn.classList.toggle("opacity-0", !show);
      btn.classList.toggle("invisible", !show);
      btn.classList.toggle("pointer-events-none", !show);
      btn.setAttribute("aria-hidden", show ? "false" : "true");
    }

    function onScroll() {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    }

    btn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion ? "auto" : "smooth",
      });
    });

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initBackToTop(document);
    });
  } else {
    initBackToTop(document);
  }
})();
